import KeyManager from "./key-manager";

class KeyManagerCreator {
    /**
     * key manager 를 생성하여 반환합니다.
     * @param id
     */
    create(el) {
        const keyManager = new KeyManager();
        keyManager.register(el);
        return keyManager;
    }
}

const keyManagerCreator = new KeyManagerCreator();

export default keyManagerCreator;